/* eslint-disable react-hooks/exhaustive-deps */
import { Edit } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import { Button, IconButton, Paper } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { PageTitle } from "../../../../shared/ui/common/index.js";
import Exports from "../../../../shared/ui/common/export.jsx";
import CustomeLayout from "../../../../shared/ui/customeTable.jsx";
import DataFetcher from "../../../../shared/api/index.js";
import { geographyTableResponse } from "../../api/table-response";
import Filters from "../../../../shared/ui/filters/index.jsx";
import { EDIT_CITY, EXPORT_CITY, GET_ALL_CITY } from "../../../../shared/api/endpoints.js";
import StateModal from "./modal.jsx";

const City = () => {
  const { userPermissions } = useSelector((state) => state.relationals);
  const [openCreate, setOpenCreate] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [editingData, setEditingData] = useState({});
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState([]);
  const [sort, setSort] = useState({});
  const [search, setsearch] = useState("");
  const [sumbitSearch, setSumbitSearch] = useState("");
  const [limit, setLimit] = useState(50);
  const [allRows, setAllRows] = useState([]);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [selected, setSelected] = useState([]);
  const [refreshData, setRefresh] = useState(0);
  const { id } = useParams();

  const parentId = searchParams.get("stateId");
  const filterApplied = useMemo(() => [...filter.filter((item) => item.name !== "provinceId"),
    ...(parentId ? [{ name: "provinceId", value: parentId, type: "eq" }] : [])], [filter, parentId]);
  const { hasMore, loading, allData, CurrentPage, metaData, header, setting } =
    DataFetcher(
      limit,
      page,
      sort,
      GET_ALL_CITY,
      filterApplied,
      true,
      refreshData,
      sumbitSearch, 1, false, geographyTableResponse
    );
  useEffect(() => {
    setAllRows(allData);
  }, [allData]);

  return (
    <>
      <PageTitle
        title={"شهر ها" + (searchParams.get("stateName") || "")}
        broadCrumb={[
          {
            title: " کشور ها ",
            path: "/country",
          },
          {
            title: "استان ها" + (searchParams.get("countryName") || ""),
            path: `/state?id=${searchParams.get(
              "countryId"
            )}&name=${searchParams.get("countryName")}`,
          },
        ]}
      />
      <div className="md:mx-3 mx-1">
        <Paper
          sx={{ border: "1px solid #dbdfea", mb: 1, padding: "15px 16px" }}
          elevation={0}
        >
          <div className="flex md:gap-4 gap-1 flex-wrap justify-between">
            <Filters
              limit={limit}
              setLimit={setLimit}
              headers={header}
              setFilter={setFilter}
              filter={filter}
              setPage={setPage}
              loading={loading}
            />
            <div className="flex justify-end flex-wrap gap-4 items-center">
                <Exports
                  sumbitSearch={sumbitSearch}
                  filter={filter}
                  header={header}
                  data={allData}
                  selectedData={selected}
                  title="کشور"
                  api={EXPORT_CITY}
                />
      

              <Button onClick={() => setOpenCreate(true)} variant="contained">
                <AddIcon />
                افزودن شهر جدید {searchParams.get("stateName") ? `برای ${searchParams.get("stateName")}` : ""}
              </Button>
            </div>
          </div>
        </Paper>
        <CustomeLayout
          limit={limit}
          setLimit={setLimit}
          setAllRows={setAllRows}
          editApi={EDIT_CITY}
          title={"شهر ها" + (searchParams.get("stateName") || "")}
          headers={header}
          setSearch={setsearch}
          search={search}
          page={page}
          total_pages={metaData?.total_pages}
          setApplySearch={(e) => {
            setPage(1);
            setSumbitSearch(e);
            /* setFilter({ ...filter, search: { value: e, type: "lk" } }); */
          }}
          rows={allRows || []}
          hasMore={hasMore}
          loading={loading}
          setPage={setPage}
          setting={setting}
          CurrentPage={CurrentPage}
          actions={[
            {
              title: "مشاهده / ویرایش منطقه",
              handler: (
                <>
                  <Button
                    onClick={() =>
                      navigate(
                        `/region?countryId=${searchParams.get(
                          "countryId"
                        )}&countryName=${searchParams.get(
                          "countryName"
                        )}&stateId=${searchParams.get(
                          "stateId"
                        )}&stateName=${searchParams.get("stateName")}&cityId=${
                          editingData?.id
                        }&cityName=${editingData?.title}`
                      )
                    }
                    variant="outlined"
                  >
                    مشاهده
                  </Button>
                </>
              ),
            },
            {
              title: "ویرایش",
              handler: (
                <>
                  <IconButton
                    onClick={() => {
                      setOpenEdit(true);
                    }}
                  >
                    <Edit sx={{ color: "#ff2000" }} />
                  </IconButton>
                </>
              ),
            },
          ]}
          length={metaData?.total}
          name={"کشور "}
          maxHeight={{ lg: "69.5vh", md: "68vh", xl: "74vh" }}
          setSort={(e) => {
            setPage(1);
            setSort({ ...sort, ...e });
          }}
          currentRow={(data) => {
            setEditingData(data);
          }}
          setRefresh={setRefresh}
          setSelected={setSelected}
          selected={selected}
        />
      </div>
      <StateModal
        open={openEdit || openCreate}
        forEdit={openEdit}
        data={editingData}
        setAllRows={setAllRows}
        allRows={allRows}
        close={() => {
          setOpenCreate(false);
          setOpenEdit(false);
          setEditingData({});
        }}
      />
    </>
  );
};

export default City;
